import React, { useState } from 'react'
import TextField from '@mui/material/TextField'
import { com } from '@eidu/form'
import MAX_KEY_LENGTH = com.eidu.sharedlib.form.validation.MAX_KEY_LENGTH
import FormKeyValidator = com.eidu.sharedlib.form.validation.FormKeyValidator

export type FormKeyFieldProp = {
  disabled: boolean
  value: string
  label?: String
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  fullWidth?: boolean
}

const FormKeyField: React.FC<FormKeyFieldProp> = ({
  value,
  label = 'Key',
  fullWidth = false,
  onChange,
  disabled = false,
}) => {
  const [keyValue, setKeyValue] = useState(value)
  const [keyLength, setKeyLength] = useState(value.length)
  const [isValidKey, setIsValidKey] = useState(FormKeyValidator.isValidKey(value))

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const text = event.target.value

    const valid = FormKeyValidator.isValidKey(text)
    setIsValidKey(valid)

    setKeyValue(text)
    setKeyLength(text.length)
    onChange(event)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: 300 }}>
      <TextField
        label={label}
        variant="outlined"
        value={keyValue}
        onChange={handleChange}
        inputProps={{ style: { fontFamily: 'monospace' } }}
        helperText={`${keyLength} / ${MAX_KEY_LENGTH}`}
        fullWidth={fullWidth}
        disabled={disabled}
        error={!isValidKey}
      />
    </div>
  )
}

export default FormKeyField
